import { GetShopMatchingSetQuery } from './getShopMatchingSet';

type GetShopMatchingSetQueryWrapper = {
  data: GetShopMatchingSetQuery;
  extensions: {
    cost: {
      'shop-product-catalog': {
        maxQueryCost: number;
        requestedQueryCost: number;
        actualQueryCost: number;
      };
    };
  };
};

export default {
  data: {
    shopContent: {
      productDetailsPage: {
        matchingSetModule: {
          isInTreatment: true,
          id: 'matching_set_module-440110-34941495',
          title: 'Matching items',
          description:
            'This item is part of a matching set — take a look at these complimentary recommendations.',
          buttonCopy: 'Add to bag',
          matchingSet: [
            {
              variant: {
                image: {
                  baseUrl:
                    'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                  mediaPath: '/v1503003357/xd1fkghrcz8rekon9rqs.jpg',
                  __typename: 'ShopMedia',
                },
                sku: '440109',
                color: {
                  uniqueColorId: '101049824',
                  name: 'Dark Grey',
                  __typename: 'Color',
                },
                inseam: null,
                price: {
                  currency: 'USD',
                  value: 2900,
                  __typename: 'Money',
                },
                size: {
                  name: 'L',
                  __typename: 'Size',
                },
                url: 'https://www.stitchfix.com/product/01-Algo-AlgoFlex-Durant-Performance-Tee/6P67MD4W3?sku-id=440109&color=Dark-Grey&size=L',
                shopProduct: {
                  externalProductId: '6P67MD4W3',
                  name: 'AlgoFlex Durant Performance Tee',
                  brand: {
                    name: '01.Algo',
                    __typename: 'Brand',
                  },
                  url: 'https://www.stitchfix.com/product/01-Algo-AlgoFlex-Durant-Performance-Tee/6P67MD4W3',
                  __typename: 'ShopProduct',
                },
                __typename: 'ShopProductVariant',
              },
              __typename: 'ShopMatchingSetItem',
            },
            {
              variant: {
                image: {
                  baseUrl:
                    'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                  mediaPath: '/v1742842391/tcwgvvb7xgkq3atxy7hb.jpg',
                  __typename: 'ShopMedia',
                },
                sku: '3588283',
                color: {
                  uniqueColorId: '101458668',
                  name: 'Dark Grey',
                  __typename: 'Color',
                },
                inseam: {
                  name: '8',
                  __typename: 'Inseam',
                },
                price: {
                  currency: 'USD',
                  value: 3900,
                  __typename: 'Money',
                },
                size: {
                  name: 'M',
                  __typename: 'Size',
                },
                url: 'https://www.stitchfix.com/product/01-Algo-AlgoFlex-Oscar-Performance-Short/Q63YMEZM3?sku-id=3588283&color=Dark-Grey&size=M&inseam=8',
                shopProduct: {
                  externalProductId: 'Q63YMEZM3',
                  name: 'AlgoFlex Oscar Performance Short',
                  brand: {
                    name: '01.Algo',
                    __typename: 'Brand',
                  },
                  url: 'https://www.stitchfix.com/product/01-Algo-AlgoFlex-Oscar-Performance-Short/Q63YMEZM3',
                  __typename: 'ShopProduct',
                },
                __typename: 'ShopProductVariant',
              },
              __typename: 'ShopMatchingSetItem',
            },
          ],
          __typename: 'ShopMatchingSetModule',
        },
        __typename: 'ShopProductDetailsPage',
      },
      __typename: 'ShopContent',
    },
  },
  extensions: {
    cost: {
      'item-price-service': {
        actualQueryCost: 6,
        maxQueryCost: 5000,
        requestedQueryCost: 5,
      },
      'shop-content-service': {
        actualQueryCost: 10,
        maxQueryCost: 5000,
        requestedQueryCost: 13,
      },
      'shop-product-catalog': {
        actualQueryCost: 38,
        maxQueryCost: 15000,
        requestedQueryCost: 28,
      },
    },
  },
} as GetShopMatchingSetQueryWrapper;

export {};
